module.exports = __webpack_public_path__ + "static/img/rightTitle.d06162a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/rightTitle.png
// module id = v7sE
// module chunks = 44